<div class="table-container">
  <table mat-table matSort [dataSource]="datapoints">
    <ng-container matColumnDef="online">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>{{'gateway-table.header.online-status' | translate}}</th>
      <td mat-cell *matCellDef="let datapoint">
        <mat-icon *ngIf="datapoint.icConnected" class="wifi-on">wifi</mat-icon>
        <mat-icon *ngIf="!datapoint.icConnected" class="wifi-off">wifi_off</mat-icon>
      </td>
    </ng-container>

    <ng-container matColumnDef="deviceName">
      <th mat-header-cell *matHeaderCellDef mat-sort-header="deviceName">{{'device-table.header.device-name' | translate}}</th>
      <td mat-cell *matCellDef="let datapoint">{{datapoint.deviceName}}</td>
    </ng-container>

    <ng-container matColumnDef="parentName">
      <th mat-header-cell *matHeaderCellDef mat-sort-header="parentName">{{'opcua-datapoint-table.header.parentname' | translate }}</th>
      <td mat-cell *matCellDef="let datapoint">{{datapoint.parentName}}</td>
    </ng-container>

    <ng-container matColumnDef="name">
      <th mat-header-cell *matHeaderCellDef mat-sort-header="name">{{'opcua-datapoint-table.header.name' | translate}}</th>
      <td mat-cell *matCellDef="let datapoint">{{datapoint.name}}</td>
    </ng-container>

    <ng-container matColumnDef="description">
      <th mat-header-cell *matHeaderCellDef mat-sort-header="description">{{'opcua-datapoint-table.header.description' | translate}}</th>
      <td mat-cell *matCellDef="let datapoint">{{datapoint.description}}</td>
    </ng-container>

    <ng-container matColumnDef="value">
      <th mat-header-cell *matHeaderCellDef mat-sort-header="value">{{'mbus-datapoint-configurator.header.value' | translate}}</th>
      <td mat-cell *matCellDef="let datapoint">{{datapoint.lastValue !== null ? formatValue(datapoint) : 'n/a'}}</td>
    </ng-container>

    <ng-container matColumnDef="unit">
      <th mat-header-cell *matHeaderCellDef mat-sort-header="unit">{{'mbus-datapoint-configurator.header.unit' | translate}}</th>
      <td mat-cell *matCellDef="let datapoint">{{datapoint.unit}}</td>
    </ng-container>

    <ng-container matColumnDef="pollingFrequency">
      <th mat-header-cell *matHeaderCellDef mat-sort-header="pollingFrequency">{{'mbus-config-table.header.polling-frequency' | translate}}</th>
      <td mat-cell *matCellDef="let datapoint">{{datapoint.pollingFrequency}} sec.</td>
    </ng-container>

    <ng-container matColumnDef="lastUpdated">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>{{'datapoint-table.header.lastUpdated' | translate}}</th>
      <td mat-cell *matCellDef="let datapoint">{{datapoint.lastUpdated | date:'dd.MM.yyyy HH:mm'}}</td>
    </ng-container>

    <ng-container matColumnDef="labels">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>{{'datapoint-table.header.labels' | translate}}</th>
      <td mat-cell *matCellDef="let datapoint" (click)="copyLabelsToClipboard(datapoint.labels)" matTooltip="Click to copy labels to clipboard" matTooltipClass="label-tooltip">
        <eis-gateway-label-chips [labels]="datapoint.labels"></eis-gateway-label-chips>
      </td>
    </ng-container>

    <ng-container matColumnDef="contextActions">
      <th mat-header-cell *matHeaderCellDef aria-label="row actions"></th>
      <td mat-cell *matCellDef="let datapoint" (click)="$event.stopPropagation()" [matMenuTriggerFor]="menu"
          [matMenuTriggerData]="{datapoint: datapoint}">
        <mat-icon class="clickable">more_vert</mat-icon>
      </td>

    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
  </table>
</div>

<mat-menu #menu="matMenu">
  <ng-template matMenuContent let-datapoint=datapoint>
    <a mat-menu-item target="_blank"href="https://app.iot.eon.com/tenants/{{tenant}}/datapoints/{{datapoint.datapointId}}">
      <mat-icon svgIcon="link-external"></mat-icon>
      {{'datapoint-table.popupmenu.eiot' | translate}}
    </a>

  </ng-template>
</mat-menu>
